import { KeyboardVoiceOutlined } from '@mui/icons-material';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/index';

import styles from './PodcastsButton.module.scss';

export const PodcastsButton = () => {
  const { currentSite } = useSite();

  return (
    <Link
      className={styles.component}
      data-ui="podcasts-button"
      href={`${currentSite?.isTeam ? currentSite?.url : ''}/shows/`}
    >
      Podcasts and shows
      <KeyboardVoiceOutlined />
    </Link>
  );
};
